import { NavLink } from "react-router";

import IdentityBadge from "./IdentityBadge";
import { useGrants } from "../lib/session";
import { effectiveRole, isPlatformAdmin, type Grants } from "../lib/scopes";

interface Props {
  onLogout: () => void;
}

interface NavItem {
  to: string;
  label: string;
  show: (g: Grants) => boolean;
}

// The four platform-admin entries sit behind the static-operator-bearer
// surfaces; offering them to a realm-admin guarantees a 401 they cannot act on.
const NAV: NavItem[] = [
  { to: "/system", label: "System", show: isPlatformAdmin },
  { to: "/organizations", label: "Organizations", show: isPlatformAdmin },
  { to: "/realms", label: "Realms", show: () => true },
  { to: "/service-accounts", label: "Service Accounts", show: isPlatformAdmin },
  { to: "/config", label: "Deployment Config", show: isPlatformAdmin },
  { to: "/me", label: "Me", show: () => true },
];

export default function Sidebar({ onLogout }: Props) {
  const grants = useGrants();
  return (
    <aside className="border-r border-kw-border-subtle p-4 flex flex-col gap-1 bg-kw-bg-elevated">
      <div className="pb-3 border-b border-kw-border-subtle mb-3">
        <div className="text-kw-l3 font-mono text-sm">kw://admin</div>
        <div className="text-xs text-kw-text-faint">{effectiveRole(grants)}</div>
      </div>
      <nav className="flex-1 flex flex-col gap-1">
        {NAV.filter((item) => item.show(grants)).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `px-3 py-2 rounded text-sm ${
                isActive
                  ? "bg-kw-bg-overlay text-kw-text-primary"
                  : "text-kw-text-muted hover:text-kw-text-primary"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="pt-3 border-t border-kw-border-subtle space-y-2">
        <IdentityBadge />
        <button
          onClick={onLogout}
          className="text-xs text-kw-text-muted hover:text-kw-text-primary text-left"
        >
          disconnect
        </button>
      </div>
    </aside>
  );
}
